export default "__VITE_ASSET__DpIeWP1o__"